if (!customElements.get('invoice-fields')) {
  customElements.define(
    'invoice-fields',
    class InvoiceFields extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('.invoice-fields__checkbox');
        this.details = this.querySelector('.invoice-fields__details');
        this.requiredFields = [...this.querySelectorAll('[data-invoice-required]')];
        this.saveTimer = null;

        this.checkbox?.addEventListener('change', () => {
          this.updateState();
          this.syncMatchingFields();
          this.saveAttributes();
        });

        this.requiredFields.forEach((field) => {
          field.addEventListener('input', () => {
            this.syncMatchingFields(field);
            window.clearTimeout(this.saveTimer);
            this.saveTimer = window.setTimeout(() => this.saveAttributes(), 550);
          });
          field.addEventListener('change', () => this.saveAttributes());
        });

        this.updateState();
      }

      updateState() {
        const isRequested = Boolean(this.checkbox?.checked);
        if (this.details) this.details.hidden = !isRequested;
        this.requiredFields.forEach((field) => {
          field.required = isRequested;
        });
      }

      syncMatchingFields(sourceField) {
        document.querySelectorAll('invoice-fields').forEach((instance) => {
          if (instance === this) return;

          const matchingCheckbox = instance.querySelector('.invoice-fields__checkbox');
          if (matchingCheckbox && this.checkbox) matchingCheckbox.checked = this.checkbox.checked;

          if (sourceField?.name) {
            const matchingField = [...instance.querySelectorAll('[data-invoice-required]')].find(
              (field) => field.name === sourceField.name
            );
            if (matchingField) matchingField.value = sourceField.value;
          } else {
            this.requiredFields.forEach((field) => {
              const matchingField = [...instance.querySelectorAll('[data-invoice-required]')].find(
                (candidate) => candidate.name === field.name
              );
              if (matchingField) matchingField.value = field.value;
            });
          }

          instance.updateState?.();
        });
      }

      async saveAttributes() {
        const attributes = {
          'Chcę fakturę VAT': this.checkbox?.checked ? 'Tak' : '',
          NIP: this.querySelector('[name="attributes[NIP]"]')?.value.trim() || '',
          'Nazwa firmy': this.querySelector('[name="attributes[Nazwa firmy]"]')?.value.trim() || '',
        };

        try {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes }),
            keepalive: true,
          });
        } catch (error) {
          // Standard checkout still submits the same fields with the cart form.
        }
      }
    }
  );
}
